import { render, staticRenderFns } from "./GatewayDetailsNotifications.vue?vue&type=template&id=91a466d8&scoped=true&"
import script from "./GatewayDetailsNotifications.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetailsNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayDetailsNotifications.vue?vue&type=style&index=0&id=91a466d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a466d8",
  null
  
)

export default component.exports